<div class="bg-card w-full overflow-x-auto pr-2">
    <table mat-table [dataSource]="registros" class="w-full">

        <!-- Código -->
        <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef> Código </th>
            <td mat-cell *matCellDef="let element"> {{ element.codigo }} </td>
        </ng-container>

        <!-- Área -->
        <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef> Área </th>
            <td mat-cell *matCellDef="let element"> {{ element.area }} </td>
        </ng-container>

        <!-- Sub área -->
        @if(!esBasico){
            <ng-container matColumnDef="subarea">
                <th mat-header-cell *matHeaderCellDef> Subárea</th>
                <td mat-cell *matCellDef="let element"> {{ element.subarea }} </td>
            </ng-container>
        }

        <!-- Ciclo -->
        <ng-container matColumnDef="ciclo">
            <th mat-header-cell *matHeaderCellDef> Ciclo </th>
            <td mat-cell *matCellDef="let element"> {{ element.ciclo?.descripcion }} </td>
        </ng-container>

        <!-- Tipo Profesional -->
        <ng-container matColumnDef="tipoProfesional">
            <th mat-header-cell *matHeaderCellDef> Tipo Profesional </th>
            <td mat-cell *matCellDef="let element"> {{ element.profesional }} </td>
        </ng-container>

        <!-- Carrera -->
        <ng-container matColumnDef="carrera">
            <th mat-header-cell *matHeaderCellDef>
                {{ esBasico ? 'Orientación Ocupacional' : 'Carrera' }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ esBasico ? element.orientacionOcupacional : element.carrera }}
            </td>
        </ng-container>

        <!-- estatus -->
        <ng-container matColumnDef="estatus">
            <th mat-header-cell *matHeaderCellDef> Estatus </th>
            <td mat-cell *matCellDef="let element" >
                <app-chip
                    [backgroundColor]="element.estadoCarrera?.valor1"
                    [text]="element.estadoCarrera.descripcion">
                </app-chip>
            </td>
        </ng-container>

                <!-- estatus -->
        <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef>  </th>
            <td mat-cell *matCellDef="let element" >

                    <button matIconButton [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">

                        <button mat-menu-item (click)="openDetails(element)" >
                            <mat-icon>edit</mat-icon>
                            <span>Detalle</span>
                        </button>
                        @if(element.estadoCarrera?.tipologiaId != TIPOLOGIA_ID_CARRERA_PUBLICADA){
                            <button *appControlAcceso="'lectura'" mat-menu-item (click)="onPublishRegistro(element)" >
                                <mat-icon>published_with_changes</mat-icon>
                                <span>Publicar</span>
                            </button>
                        }
                        <button *appControlAcceso="'lectura'" mat-menu-item (click)="onEliminarRegistro(element)" >
                            <mat-icon>delete</mat-icon>
                            <span>Eliminar</span>
                        </button>
                    </mat-menu>


            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</div>
